import React, { useState } from 'react'
import axios from 'axios'
import { Field, FieldArray, Form, Formik } from 'formik'
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

import '../../../styles/Admin.css'
import { FaTrashAlt } from 'react-icons/fa';

const ADMIN_PROJECT_URL = 'admin/auth/projects'

const ProjectsSchema = Yup.object().shape({
    title: Yup.string()
        .min(8, 'Title too short')
        .max(55, 'Title too long')
        .required('Required'),
    team_lead_name: Yup.string()
        .min(3, 'Title too short')
        .required('Required'),
    team_lead_batch: Yup.string()
        .required('Required'),
    description: Yup.string()
        .min(12, 'Title too short')
        .required('Required'),
    domain: Yup.string(),
    tech_stack: Yup.array(),
    team_members: Yup.array(),
    links: Yup.array(),
});

const AddProjects = () => {

    const [loading, setLoading] = useState(false)

    const token = localStorage.getItem('token')
    const navigate = useNavigate()

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="/admin/project" className='breadcrumb__link'>
                            Project   
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Add
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Add Project</h3>
                    <Formik
                        initialValues={{
                            title: '',
                            team_lead_name: '',
                            team_lead_batch: '',
                            description: '',
                            domain: '',
                            tech_stack: '',
                            team_members: [],
                            links: []
                        }}
                        validationSchema={ProjectsSchema}
                        onSubmit={async (data) => {
                            setLoading(true)
                            axios.post(`${process.env.REACT_APP_DEPT_API}/${ADMIN_PROJECT_URL}/add`, data, {
                                headers: {
                                    authorization: `Bearer ${token}`
                                }
                            }).then(() => {
                                setLoading(false)
                                alert("Added successfully")
                                navigate('/admin/project/')
                            }).catch(err => {
                                console.log(err)
                                alert("Error occured. Check console logs")
                            })
                        }}
                    >
                        {({ errors, values }) => (
                            <Form className='admin_form_container'>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Title* </p>
                                    <label htmlFor="title">
                                        <Field className='admin_input' id="title" name="title" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.title}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Team Lead Name* </p>
                                    <label htmlFor="team_lead_name">
                                        <Field className='admin_input' id="team_lead_name" name="team_lead_name" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.team_lead_name}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Team Lead Batch* </p>
                                    <label htmlFor="team_lead_batch">
                                        <Field className='admin_input' id="team_lead_batch" name="team_lead_batch" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.team_lead_batch}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Description* </p>
                                    <label htmlFor="description">
                                        <Field className='admin_input admin_textarea' as="textarea" id="description" name="description" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.description}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Domain </p>
                                    <label htmlFor="domain">
                                        <Field className='admin_input' id="domain" name="domain" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.domain}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Tech stack</p>
                                    <FieldArray name="tech_stack">
                                        {({ insert, remove, push }) => (
                                            <div>
                                                {values.tech_stack && values.tech_stack.length > 0 &&
                                                    values.tech_stack.map((member, index) => (
                                                        <div className="fpu-academic-sub-row" key={index}>
                                                            <div className="fpu-academic-sub-row-col1">
                                                                <Field
                                                                    name={`tech_stack.${index}`}
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div className="fpu-academic-sub-row-col2">
                                                                <button
                                                                    type="button"
                                                                    className="secondary"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    X
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                <button
                                                    type="button"
                                                    className="fpu-add-btn"
                                                    onClick={() => push('')}
                                                >
                                                    Add Technology
                                                </button>
                                            </div>
                                        )}
                                    </FieldArray>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Team Members</p>
                                    <FieldArray name="team_members">
                                        {({ insert, remove, push }) => (
                                            <div>
                                                {values.team_members && values.team_members.length > 0 &&
                                                    values.team_members.map((member, index) => (
                                                        <div className="fpu-academic-sub-row" key={index}>
                                                            <div className="fpu-academic-sub-row-col1">
                                                                <Field
                                                                    name={`team_members.${index}`}
                                                                    type="text"
                                                                />
                                                            </div>
                                                            <div className="fpu-academic-sub-row-col2">
                                                                <button
                                                                    type="button"
                                                                    className="secondary"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    X
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                <button
                                                    type="button"
                                                    className="fpu-add-btn"
                                                    onClick={() => push('')}
                                                >
                                                    Add Member
                                                </button>
                                            </div>
                                        )}
                                    </FieldArray>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Links</p>
                                    <FieldArray name="links">
                                        {({ insert, remove, push }) => (
                                            <div>
                                                {values.links && values.links.length > 0 &&
                                                    values.links.map((sm, index) => (
                                                        <div className="cpu-sm-sub-row" key={index}>
                                                            <div className='cpu-sm-sub-row-col'>
                                                                <div>
                                                                    <label htmlFor={`links.${index}.title`}>Title</label>
                                                                    <Field
                                                                        name={`links.${index}.title`}
                                                                        type="text" placeholder="eg: Github"
                                                                    />
                                                                </div>
                                                                <div className="col">
                                                                    <label htmlFor={`links.${index}.link`}>Link</label>
                                                                    <Field
                                                                        name={`links.${index}.link`}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='cpu-sm-sub-row-col'>
                                                                <button
                                                                    type="button"
                                                                    className="secondary"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    <FaTrashAlt />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                <button
                                                    type="button"
                                                    className="cpu-add-btn "
                                                    onClick={() => push({ title: '', link: '' })}
                                                >
                                                    Add Link
                                                </button>
                                            </div>
                                        )}
                                    </FieldArray>
                                </div>
                                <button disabled={loading ? true : false} className='admin_btn' type="submit">
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    )
}

export default AddProjects